export default "__VITE_ASSET__Bdt4tYDA__"